<template>
    <div class="title">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "ManageTitle"
};
</script>

<style scoped>
.title {
    /*margin-left: 0.15rem;*/
    height: 60px;
    line-height: 60px;
    padding: 0 40px;
    border-bottom: 1px #e5e8ec solid;
    font-size: 16px;
    font-weight: 500;
}
</style>
